<div class="all-instructions">
  <h5 class="instructions-title">{{ task.instructionsTitle }}</h5> <p [innerHTML]="task.instructions"></p>
</div>

<div class="section visit-reason" style="padding-left: 0px; padding-right: 0px;">
  <button
    (click)="startBookingAppointmentWithTask()"
    class="btn btn-primary btn-lg btn-block mb-3"
    *ngIf="task.isAssigned"
  >
    Book Visit
  </button>
</div>

<div>
  <h5>{{ task.taskOptionsTitle }}</h5> <p>{{ task.taskOptionsDescription }}</p>
</div>
